const base = ['registry-admin'] as const;
export const registryAdminKeys = {
  get: (itemID: string | undefined) => [...base, { itemID }] as const,
  list: () => [...base, 'list'] as const,
};
